import { BrregOrgDto } from "../../autogen/bff-api";

export interface PostalAddress {
  street: string;
  postCode: string;
  city: string;
}

export function toPostalAddress(org: BrregOrgDto): PostalAddress {
  const address = org.businessAddress;
  return {
    street: address?.streetLines?.join(", ") ?? "",
    postCode: address?.postCode ?? "",
    city: address?.city ?? "",
  };
}

export function formatPostalAddress(org: BrregOrgDto): string {
  const { street, postCode, city } = toPostalAddress(org);
  const cityLine = [postCode, city].filter(Boolean).join(" ");
  return [street, cityLine].filter(Boolean).join(", ");
}
